<!--
  TODO:
    This file is outdated and should be rebuilt the same way that the freelancer page is built.
    By the use of more generalize components.
    More of the business logic should also be moved back to the backend til the job filter.
    The frontend should be more focused on caching searches and making searches seamless.
-->
<template>
  <div id="list-with-elements">
    <div v-if="searchingJobs" class="text-center p-20">
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <DisplaySkeleton />
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <DisplaySkeleton />
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <DisplaySkeleton />
    </div>
    <div v-else id="jobslistcontainer">
      <div v-if="!isDashboard()" class="row">
        <div class="col-sm-12">
          <div class="pull-left">
            <p v-if="!updating" class="lead">
              {{ textResultsCount }}
            </p>
            <div v-else id="JobNumberLoader" class="pls-blue">
              <p class="lead">{{ $t('jobs found (loading, no number yet)') }}</p>
              <svg class="pl-circular" viewBox="25 25 50 50">
                <circle class="plc-path" cx="50" cy="50" r="20" />
              </svg>
            </div>
          </div>
          <div class="pull-right tw-flex tw-items-center">
            <div class="tw-mr-6">
              <WdsButtonText href="/profiles">
                {{ $t('View other freelancers') }}
              </WdsButtonText>
            </div>
            <a href="/jobs/liked" class="btn btn-default waves-effect" style="padding: 4px 12px">
              <span
                class="glyphicon glyphicon-heart"
                style="color: #747487; top: 2px; margin-right: 8px"
              ></span>
              {{ $t('Saved') }}
            </a>
          </div>
        </div>
      </div>
      <div id="profile-list-results" class="profile-list">
        <div v-if="updating" id="loadingOverlay" />
        <div v-if="gotJobs()" class="card">
          <div v-if="oldList" class="list-group lg-odd-black">
            <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
            <list-item-card
              v-for="job in oldList.slice(0, displayNumber)"
              :key="job.id"
              :card="job"
              :parent="job.company"
              :avatar-url="job.company && !userIsCompany ? job.company.avatar_path : undefined"
              :card-destination-url="job.id ? `job/${job.id}` : undefined"
              :card-title="job.name"
              :card-name="job.company ? job.company.name || job.company.company : ''"
              :show-likes="!userIsCompany && format === 'default'"
              :show-rate="format === 'default'"
              :location="getLocation(job)"
              :compact="format === 'compact'"
              :disable-skills-click="format === 'compact'"
            />
          </div>
        </div>
        <div v-else class="no-jobs alert alert-info p-10">
          <p>
            {{ noJobsMsg }}
          </p>
        </div>
      </div>

      <div v-if="displayUpdateProfileToMatchMsg" class="card">
        <div class="card-padding card-body">
          <h4 class="c-black">{{ $t('Get more job matches') }}</h4>
          <p class="m-b-0">
            {{ $t('Update your profile to help our algorithm match you even better.') }}
            <br />
            {{ $t('See how you do here (with link)') }}
          </p>
        </div>
      </div>

      <div v-if="showExtraMarketJobs">
        <div class="card bgm-purple rounded m-b-5">
          <div class="card-padding card-body p-t-10 p-b-15">
            <h4 class="c-white f-500">
              {{ $t('We have found additional jobs in other markets.') }}
            </h4>
            <p class="m-b-0 f-13 c-white">
              {{ $t('If you find them relevant, make sure to update your preferred markets.') }}
              <a href="/profile/edit#markets" class="btn m-l-10 btn-default btn-xs">
                {{ $t('Update here') }}
              </a>
              <br />
              {{ $t('You will then be matched with jobs in those markets in the future.') }}
            </p>
          </div>
        </div>
        <div class="profile-list">
          <div class="card">
            <div v-if="recommendedJobs" class="list-group lg-odd-black">
              <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
              <list-item-card
                v-for="job in recommendedJobs.slice(0, secondDisplayNumber)"
                :key="job.id"
                :card="job"
                :parent="job.company"
                :avatar-url="job.company && !userIsCompany ? job.company.avatar_path : undefined"
                :location="getLocation(job)"
                :card-title="job.name"
                :card-name="job.company ? job.company.name || job.company.company : ''"
                :card-destination-url="job.id ? `job/${job.id}` : undefined"
                :recommended="true"
                :show-rate="true"
                :show-likes="!userIsCompany"
                :disable-skills-click="format === 'compact'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WdsButtonText } from '@worksome/wds-components'
import { $tc } from '@/app-bootstrapping/SetUpInternationalization'

const sleepTime = 100 // The time we take to show that we are loading jobs in ms

function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms)
  })
}

export default {
  name: 'AppListJob',
  components: { WdsButtonText },
  props: {
    jobs: {
      type: Array,
      required: true,
    },
    recommendedJobs: {
      type: Array,
      required: true,
    },
    refFilter: {
      type: Object,
      required: true,
    },
    refStore: {
      type: Object,
      required: false,
    },
    version: {
      type: String,
      required: false,
    },
    format: {
      type: String,
      required: false,
    },
    useGivenJobs: {
      type: Boolean,
      default: false,
    },
    canLikeJobs: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
      default: true,
    },
  },
  data() {
    return {
      oldList: [],
      filter: {
        regions: {
          list: [],
        },
        search: {
          searching: false,
        },
        sortBy: 'desc',
      },
      displayNumber: this.isDashboard() ? 5 : 15,
      secondDisplayNumber: 10,
      bottom: false,
      updating: false,
      firstFilterHasRun: false,
      noJobsMsg: `${$t('We found no jobs')} ${$t('Change the filter on the left to see all jobs')}`,
      displayUpdateProfileToMatchMsg: false,
    }
  },
  computed: {
    binder: {
      get() {
        return this.filter.sortBy
      },
      set(val) {
        if (this.refStore) {
          this.refStore.store.commit(this.refStore.mutater, val)
        } else {
          this.filter.sortBy = val
        }
      },
    },
    searchingJobs() {
      return this.$store.getters.searchingForCurrentJobs
    },
    userIsCompany() {
      return typeof this.account === 'object' && this.account.isCompany
    },
    userActiveInAllMarkets() {
      if (
        // This checks if we have all markets selected
        this.filter.markets.list &&
        this.filter.markets.selected.length === Object.keys(this.filter.markets.list).length &&
        Object.keys(this.$store.getters.filter.markets.list).length > 0
      ) {
        // We have currently all markets selected, so we don't need to show any extra markets, as they are all ready
        // being displayed
        return true
      }
      if (
        // This checks if the user is all ready active in all markets
        this.account.markets &&
        this.account.markets.length > 0 &&
        this.$store.getters.filter.markets.list &&
        Object.keys(this.$store.getters.filter.markets.list).length > 0
      ) {
        const isIn = []
        // eslint-disable-next-line guard-for-in -- Baseline eslint ignore please fix if working on this
        for (const market in this.$store.getters.filter.markets.list) {
          isIn[market] = false
        }
        for (let i = 0; i < this.account.markets.length; i++) {
          const market = this.account.markets[i]
          isIn[market] = true
        }
        for (const is in isIn) {
          if (!isIn[is]) {
            return false
          }
        }
        return true
      }
      // We just don't know yet
      return undefined
    },
    showExtraMarketJobs() {
      return (
        parseInt(this.filter.relevance.selected, 10) === 0 &&
        !this.filter.search.searching &&
        !this.userIsCompany &&
        this.recommendedJobs &&
        this.recommendedJobs.length > 0 &&
        !this.recommendedJobs[0]['no-jobs-msg'] &&
        this.oldList &&
        this.displayNumber >= this.oldList.length &&
        this.userActiveInAllMarkets !== undefined &&
        !this.userActiveInAllMarkets
      )
    },
    jobsFiltered() {
      if (this.useGivenJobs) {
        return this.jobs
      }
      return this.$store.getters.jobsListFiltered
    },
    textResultsCount() {
      const countResults = this.jobs && this.gotJobs() ? this.jobsFiltered.length : 0
      return $tc(':count job found | :count jobs found', countResults)
    },
  },
  watch: {
    bottom(bottom) {
      if (bottom) {
        this.loadMoreJobs()
      }
    },
    jobs: {
      deep: true,
      handler() {
        this.animateMoreJobs()
      },
    },
    jobsFiltered: {
      deep: true,
      handler() {
        this.animateMoreJobs()
      },
    },
    filter: {
      handler(from, to) {
        // Filter has been updated, so we reset the number of displayed jobs
        this.displayNumber = this.isDashboard() ? 5 : 15
        this.secondDisplayNumber = 10
        // Animate the number of jobs, to indicate that something happened
        if (this.account.isApproved) {
          this.displayUpdateProfileToMatchMsg =
            !this.filter.search.searching && parseInt(this.filter.relevance.selected, 10) === 0
        }
      },
      deep: true,
    },
  },
  created() {
    this.filter = this.refFilter
    this.displayUpdateProfileToMatchMsg = false
    window.addEventListener('scroll', this.bottomVisible)
  },
  methods: {
    /**
     * This function adds a fake loading time on the page, every time the filter is updated
     * This is simply to make the site more alive while giving feedback to the user that
     * their actions have an impact
     */
    async animateMoreJobs() {
      this.updating = true
      const filtered = this.jobsFiltered

      // This statement ensures that we don't end up displaying an empty page a split second before rendering the acutal jobs
      // Currently disable since it can cause a bug where no jobs are displayed even if there are jobs. (needs to be looked more into)
      // eslint-disable-next-line eqeqeq -- Baseline eslint ignore please fix if working on this
      if (false && !this.firstFilterHasRun && this.jobs.length != 0) {
        this.firstFilterHasRun = true
      } else {
        await sleep(sleepTime)
      }

      await sleep(sleepTime)
      this.oldList = filtered
      this.updating = false
    },
    /**
     * Simply loads more jobs that can now be displayed
     */
    loadMoreJobs() {
      if (!this.isDashboard()) this.displayNumber += 15
      if (this.showExtraMarketJobs && this.secondDisplayNumber < 50) this.secondDisplayNumber += 10
    },
    /**
     * Sees if the bottom is visible
     */
    bottomVisible() {
      const scrollY = window.pageYOffset
      const visible = document.documentElement.clientHeight
      const listHeight = document.getElementById('list-with-elements')?.scrollHeight ?? 0 // Fails in sentry at times
      this.bottom = visible + scrollY >= listHeight
    },

    /**
     * This functions ensures that if we get the no jobs message, that we display it,
     * otherwise we check to see if we have jobs in the list left
     */
    gotJobs() {
      if (
        // eslint-disable-next-line eqeqeq -- Baseline eslint ignore please fix if working on this
        this.jobs.length == 1 &&
        this.jobs[0]['no-jobs-msg'] &&
        // eslint-disable-next-line eqeqeq -- Baseline eslint ignore please fix if working on this
        this.jobs[0]['no-jobs-msg'] != ''
      ) {
        this.noJobsMsg = this.jobs[0]['no-jobs-msg']
        return false
      }

      this.noJobsMsg = `${$t('We found no jobs')} ${$t(
        'Change the filter on the left to see all jobs',
      )}`

      return this.jobs.length > 0
    },
    isDashboard() {
      return this.version === 'dashboard'
    },
    getFormat() {
      return this.format
    },
    getLocation(job) {
      if (job.company && job.company.primary_location && job.company.primary_location.city) {
        let location = `, ${job.company.primary_location.city}`

        if (job.company.primary_location.state) {
          location += `, ${job.company.primary_location.state}`
        }

        return location
      }
      return ''
    },
  },
}
</script>

<style scoped lang="scss">
#JobNumberLoader {
  position: relative;
  display: inline-block;
  p {
    margin-left: 30px;
  }
  svg {
    width: 25px;
    height: 25px;
    margin: 5px 0 0 0;
    circle {
      stroke: #2196f3;
      animation: dash 1.5s ease-in-out infinite;
    }

    @media screen and (max-width: 768px) {
      width: 20px;
      height: 20px;
      margin-top: 0px;
    }
  }
}

.no-jobs {
  padding: 5px;
}

#profile-list-results {
  position: relative;
}

#loadingOverlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  opacity: 0.3;
  z-index: 10;
}
</style>
